// extracted by mini-css-extract-plugin
export default {"box":"PendingRequestBox_box__4yLCB","text":"PendingRequestBox_text__Rkcbl"};